import type { AdminCustomerCart, Scan, StoreCustomer } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";

export class CustomerScansState {
  /** The selected shop, or null until it is known. */
  readonly storeId = new Rx<string | null>(null);
  readonly customersStatus = new Rx<LoadStatus>(idleLoad);
  readonly customers = new RxList<StoreCustomer>();
  /** The customer drilled into, when the route names one. */
  readonly selectedCustomer = new Rx<StoreCustomer | null>(null);
  readonly scansStatus = new Rx<LoadStatus>(idleLoad);
  readonly scans = new RxList<Scan>();
  /** Open carts at this counter, for the Carts tab's count. */
  readonly openCarts = new Rx(0);
  /** The selected customer's open cart, if they have one. */
  readonly cart = new Rx<AdminCustomerCart | null>(null);
  /** Until the cart has loaded, Add to cart could open a second one for a customer who has one. */
  readonly cartStatus = new Rx<LoadStatus>(idleLoad);
  /** The scan an add or remove is running for. */
  readonly busyScanId = new Rx<string | null>(null);
  readonly actionError = new Rx<string | null>(null);
  /** The "Add customer" dialog, open when not null. */
  readonly newCustomer = new Rx<NewCustomerDraft | null>(null);

  constructor(readonly customerId: string | null) {}
}

export interface NewCustomerDraft {
  readonly name: string;
  readonly busy: boolean;
  readonly error: string | null;
}

export abstract class CustomerScansActions {
  abstract selectCustomer(id: string): void;
  abstract showAllCustomers(): void;
  abstract editScan(scan: Scan): void;
  abstract showQr(): void;
  abstract retry(): void;
  abstract addToCart(scan: Scan): Promise<void>;
  abstract removeFromCart(scan: Scan): Promise<void>;
  abstract checkout(): void;
  abstract scanForCustomer(): void;
  abstract dismissActionError(): void;
  abstract openNewCustomer(): void;
  abstract setNewCustomerName(name: string): void;
  abstract closeNewCustomer(): void;
  abstract createCustomer(): Promise<void>;
}
